import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import axios from '../api/axios';

function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('No verification token found in the URL.');
      return;
    }

    axios.get(`/public/verify-email?token=${encodeURIComponent(token)}`)
      .then(() => {
        setStatus('success');
        // Redirect to onboarding after 2 seconds
        setTimeout(() => navigate('/onboarding'), 2000);
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.response?.data?.message || 'Email verification failed. The link may have expired.');
      });
  }, []);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f2f5' }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: 40, maxWidth: 440, width: '90%', textAlign: 'center', boxShadow: '0 4px 24px rgba(0,0,0,0.08)' }}>
        {status === 'verifying' && (
          <>
            <div style={{ fontSize: 48, marginBottom: 16 }}>⏳</div>
            <h2>Verifying your email...</h2>
            <p style={{ color: '#6c757d' }}>Please wait a moment.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
            <h2>Email Verified!</h2>
            <p style={{ color: '#6c757d' }}>Redirecting you to onboarding...</p>
          </>
        )}
        {status === 'error' && (
          <>
            <div style={{ fontSize: 48, marginBottom: 16 }}>❌</div>
            <h2>Verification Failed</h2>
            <p style={{ color: '#6c757d' }}>{message}</p>
            <Link to="/login" style={{ color: '#4f46e5', fontWeight: 600 }}>Back to Login</Link>
          </>
        )}
      </div>
    </div>
  );
}

export default VerifyEmail;
